var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3095_5653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.25C5.29565 23.25 6.05871 22.9339 6.62132 22.3713C7.18393 21.8087 7.5 21.0456 7.5 20.25V0.75H23.25V20.25C23.25 21.0456 22.9339 21.8087 22.3713 22.3713C21.8087 22.9339 21.0456 23.25 20.25 23.25H4.5ZM4.5 23.25C3.50544 23.25 2.55161 22.8549 1.84835 22.1517C1.14509 21.4484 0.75 20.4946 0.75 19.5V15H7.5",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.25H23.25",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6H12",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9H12",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12H12",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15H12",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3095_5653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalEntry);
export default __webpack_public_path__ + "static/media/journalEntry.55dca8f42f33e51f8151866b90a63865.svg";
export { ForwardRef as ReactComponent };